import React from 'react';
import icon from '../images/icon.jpg'
import bg from '../images/bg-hero.jpg'
import Header from './organisms/header';

function Intro() {
  return (
    <section id="intro" className="intro">
      <div className="w-full bg-center bg-cover relative bg-no-repeat" style={{ backgroundImage: `url(${bg})` }}>
        <Header />
        <div className="flex items-center justify-center bg-gray-900 bg-opacity-50 py-5">
          <div className="container relative z-30 pt-20 pb-12 sm:pt-56 sm:pb-48 lg:pt-64 lg:pb-48">
            <div className="flex flex-col items-center justify-center lg:flex-row">

              {/* .float は transform を使うので、app-in の transform と競合しないよう入れ子にする */}
              <div className="app-in app-in-1">
                <div className="float rounded-full border-8 border-gray-800 shadow-xl">
                  <img src={icon} className="h-48 rounded-full sm:h-56" alt="author" />
                </div>
              </div>

              <div className="pt-8 sm:pt-10 lg:pl-8 lg:pt-0">
                <h1 className="app-in app-in-2 text-center font-header text-4xl sm:text-left sm:text-5xl md:text-6xl text-white">
                  Hello I'm Taiga Kishimoto!
                </h1>

                <div className="app-in app-in-3 flex flex-col justify-center pt-3 sm:flex-row sm:pt-5 lg:justify-start">
                  <div className="flex items-center justify-center pl-0 sm:justify-start md:pl-1">
                    <p className="m-0 font-body text-lg uppercase text-white">Let's connect</p>
                    <div className="hidden sm:block">
                      <i className="bx bx-chevron-right text-3xl text-white"></i>
                    </div>
                  </div>

                  <div className="grid-cols-1">

                    <div className="flex items-center justify-center pl-2 sm:justify-start sm:pt-0">
                      <a href="https://www.facebook.com/taiga.kishimoto.14" target="_blank" rel="noopener noreferrer" className="pl-4"><i className="bounce-icon bx bxl-facebook-square text-2xl text-white hover:text-yellow"></i></a>
                      <a href="http://twitter.com/koneko59" target="_blank" rel="noopener noreferrer" className="pl-4"><i className="bounce-icon bx bxl-twitter text-2xl text-white hover:text-yellow"></i></a>
                      <a href="/" className="pl-4"><i className="bounce-icon bx bxl-dribbble text-2xl text-white hover:text-yellow"></i></a>
                      <a href="http://www.linkedin.com/in/taiga-kishimoto" target="_blank" rel="noopener noreferrer" className="pl-4"><i className="bounce-icon bx bxl-linkedin text-2xl text-white hover:text-yellow"></i></a>
                    </div>

                    <div className="flex items-center justify-center pl-2 sm:justify-start sm:pt-0">
                      <i className="bx bx-envelope text-2xl text-white hover:text-yellow"></i>
                      <p className="px-2 text-left font-body text-white hover:text-yellow lg:text-lg">
                        tiger53990@gmail.com
                      </p>
                    </div>

                    <div className="flex items-center justify-center pl-2 sm:justify-start sm:pt-0">
                      <i className="bx bx-phone text-2xl text-white hover:text-yellow"></i>
                      <p className="px-2 text-left font-body text-white hover:text-yellow lg:text-lg">
                        080 5718 8571
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="app-in app-in-4 flex justify-center pt-16">
              <a href="#about" className="float font-display tracking-[0.3em] text-sm text-white" aria-label="次のセクションへ">
                SCROLL
                <span className="mx-auto mt-2 block h-8 w-px bg-white/70"></span>
              </a>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}

export default Intro;
